import { memo } from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { useTheme } from '../../theme';
import { formatCompact, formatDate, formatDateShort } from '../../utils';
import { ChartTooltip } from '../ui/ChartTooltip';

export const StackedBarChart = memo(({ data, series, valueFormatter, height = 280, totalLabel }) => {
  const { palette } = useTheme();
  const barSize = data.length > 45 ? undefined : data.length > 20 ? 12 : 22;

  return (
    <div className='wm-chart' style={{ height }}>
      <ResponsiveContainer width='100%' height='100%'>
        <BarChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: 0 }} barCategoryGap='20%'>
          <CartesianGrid vertical={false} strokeDasharray='3 4' />
          <XAxis
            dataKey='date'
            tickFormatter={formatDateShort}
            tickLine={false}
            axisLine={false}
            minTickGap={24}
            tickMargin={10}
          />
          <YAxis tickFormatter={formatCompact} tickLine={false} axisLine={false} width={72} tickMargin={6} />
          <Tooltip
            cursor={{ fill: palette.surfaceHover }}
            content={
              <ChartTooltip
                labelFormatter={label => formatDate(label)}
                valueFormatter={valueFormatter}
                items={payload => [
                  ...payload,
                  ...(totalLabel
                    ? [
                        {
                          name: totalLabel,
                          dataKey: 'total',
                          value: payload.reduce((sum, p) => sum + (Number(p.value) || 0), 0),
                          color: 'transparent',
                        },
                      ]
                    : []),
                ]}
              />
            }
          />
          {series.map((s, i) => (
            <Bar
              key={s.key}
              dataKey={s.key}
              name={s.name}
              stackId='stack'
              fill={s.color}
              barSize={barSize}
              radius={i === series.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0]}
              animationDuration={600}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
});
